import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './number-of-rooms.reducer';

export const NumberOfRoomsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const numberOfRoomsEntity = useAppSelector(state => state.numberOfRooms.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="numberOfRoomsDetailsHeading">
          <Translate contentKey="apiLocationApp.numberOfRooms.detail.title">NumberOfRooms</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.numberOfRooms.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.numberOfRooms.date">Date</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.numberOfRooms.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.numberOfRooms.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllHouseholds">
              <Translate contentKey="apiLocationApp.numberOfRooms.totalAllHouseholds">Total All Households</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.totalAllHouseholds}</dd>
          <dt>
            <span id="oneRoom">
              <Translate contentKey="apiLocationApp.numberOfRooms.oneRoom">One Room</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.oneRoom}</dd>
          <dt>
            <span id="twoRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.twoRooms">Two Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.twoRooms}</dd>
          <dt>
            <span id="threeRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.threeRooms">Three Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.threeRooms}</dd>
          <dt>
            <span id="fourRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.fourRooms">Four Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.fourRooms}</dd>
          <dt>
            <span id="fiveRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.fiveRooms">Five Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.fiveRooms}</dd>
          <dt>
            <span id="sixRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.sixRooms">Six Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.sixRooms}</dd>
          <dt>
            <span id="sevenRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.sevenRooms">Seven Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.sevenRooms}</dd>
          <dt>
            <span id="eightRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.eightRooms">Eight Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.eightRooms}</dd>
          <dt>
            <span id="nineOrMoreRooms">
              <Translate contentKey="apiLocationApp.numberOfRooms.nineOrMoreRooms">Nine Or More Rooms</Translate>
            </span>
          </dt>
          <dd>{numberOfRoomsEntity.nineOrMoreRooms}</dd>
        </dl>
        <Button tag={Link} to="/number-of-rooms" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/number-of-rooms/${numberOfRoomsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default NumberOfRoomsDetail;
